import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgeGroup, DocumentReference, NameValue, SportTeam } from '../../core/models';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  DocumentService, MemberService, FestivalUserService, SportTeamService, ServiceYearMemberService
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { ModalController, AlertController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';
import { TextService } from 'src/core/services/text-service';

@Component({
  selector: 'app-edit-member',
  templateUrl: './edit-member.component.html',
  styleUrls: ['./edit-member.component.less', '../../core/styles/common.less']
})

export class EditMemberComponent extends PageClass implements OnInit {

  @Input() memberGroup: any = {};

  member: any;
  ageGroupList: DocumentReference [];
  sportTeamList: SportTeam[];
  genderList: NameValue [];
  priestList: DocumentReference [] = [];
  yearList: DocumentReference [];
  yesNoList: string[] = ['Yes', 'No'];

  isTeamMember = false;
  disableChurch = false;
  isLoading = true;

  @ViewChild('memberForm', null) memberForm: NgForm;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    private memberService: MemberService,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,
    private serviceYearMemberService: ServiceYearMemberService,
    private modalController: ModalController,
    private alertController: AlertController,
    private textService: TextService
  ) {
      super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  public loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      this.getLists();
    } else {
      this.dismissModal();
    }
  }

  async populateLists() {
    this.memberGroup.ageGroup = this.ageGroupList.find(g => g.reference.id === this.memberGroup.ageGroup.reference.id);

    var teamMember = {
      displayName: `${this.memberGroup.member.displayName} - ${this.memberGroup.yearLevel.displayName} - ${this.memberGroup.gender?.name}`, 
      reference: this.databaseService.doc(`serviceYearMembers/${this.memberGroup.id}`).ref
    };

    (await this.sportTeamService.getMemberTeams(teamMember)).subscribe (sportTeamList => {
      this.sportTeamList = sportTeamList;

      this.disableChurch = this.sportTeamList?.length > 0 || !this.currentUser.isAdmin;
      
      if (this.sportTeamList.length > 0) {
        this.isTeamMember = true;
        this.teamAlert();
      }
    });

    this.populateYearList();
    this.isLoading = false;
  }

  async populateYearList() {
    const ageGroup = await this.documentService.getDocumentById('ageGroups', this.memberGroup.ageGroup.reference.id);

    this.yearList = (ageGroup as AgeGroup).yearLevelList;
    if (this.memberGroup.yearLevel) {
      this.memberGroup.yearLevel = this.yearList.find(y => y.reference.id === this.memberGroup.yearLevel.reference.id);
    }

    if (this.member.fatherOfConfession) {
      this.member.fatherOfConfession = this.priestList.find(p => p.reference.id == this.member.fatherOfConfession.reference.id);
    }
  }

  async getLists() {
    this.genderList = this.memberService.getGenderList();
    
    // Get Member
    this.member = await this.documentService.getDocumentById('members', this.memberGroup.member.reference.id);
    this.member.id = this.memberGroup.member.reference.id;
    (await this.festivalUserService.getPriests()).subscribe(priestList => {
      priestList.forEach(priest => {
        this.priestList.push(
          {
            displayName: priest.user.displayName,
            reference: this.databaseService.doc(`${this.festivalUserService.collection}/${priest.id}`).ref
          }
        );

        this.priestList.sort(this.arrayService.orderByDisplayName);
      });
    });

    this.ageGroupList = this.currentUser.ageGroupList;
    
    if (!this.currentUser.isAdmin) {
      this.memberGroup.church = this.churchList.find(c => c.reference.id === this.memberGroup.church.reference.id);
      this.member.church = this.memberGroup.church;
      this.populateLists();
    } else {
      this.memberGroup.church = this.churchList.find(c => c.reference.id === this.memberGroup.church.reference.id);
      this.member.church = this.memberGroup.church;

      this.populateLists();
    }
  }

  async editMember() {
    if (this.memberForm.invalid) {
      return;
    }

    this.member = {
      ...this.member,
      firstName: this.textService.toPascalCase(this.member.firstName),
      lastName: this.textService.toPascalCase(this.member.lastName),
      updatedBy: this.currentUser.user,
      updatedAt: new Date().getTime()
    }

    if (this.member.fatherOfConfession == undefined)
      this.member.fatherOfConfession = null;


    this.memberGroup = {
      ...this.memberGroup,
      gender: this.member.gender,
      member:{
        reference: this.databaseService.doc(`members/${this.memberGroup.member.reference.id}`).ref,
        displayName: `${this.member.firstName} ${this.member.lastName}`
      },
      updatedBy: this.currentUser.user,
      updatedAt: new Date().getTime()
    }

    this.documentService.updateDocument(this.memberService.collection, this.member);
    this.documentService.updateDocument(this.serviceYearMemberService.collection, this.memberGroup);

    this.dismissModal();
  }

  requireFatherOfConfession() {
    const arrayList = ['Years (1 - 3)', 'Prep'];
    return this.memberGroup && this.memberGroup.ageGroup &&
     !arrayList.includes(this.memberGroup.ageGroup.displayName);
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  teamAlert = async () => {
    let errorMessage = "<p>You cannot edit part of the member details since member is in the following teams</p> ";

    this.sportTeamList.forEach(sportTeam => {
      errorMessage += `<li>${sportTeam.displayName}</li>`;      
    });

    const alert = await this.alertController.create({
      header: 'Cannot Edit Member',
      message: errorMessage,
      buttons: ['OK'],
    });

    await alert.present();
  }
}
